import { multiFactor, TotpMultiFactorGenerator, TotpSecret, User as UserImpl } from "firebase/auth";
import { User as MFAUser } from '~/components/Settings/MFA/page';
export type UserToCreate = UserImpl

export type Roles = string[];

export function isRoles(arg: unknown): arg is Roles {
  if (Array.isArray(arg)) {
    return arg.every((item) => typeof item === "string");
  }
  if (arg === null) {
    return false;
  }
  return false;
}

export class User implements MFAUser {
  getRoles() {
    return this.roles;
  }

  constructor(private payload: UserToCreate, private roles: Roles) {

  }

  async getToken() {
    return this.payload.getIdToken();
  }

  async generateTOTPSecret() {
    const multiFactorSession = await multiFactor(this.payload).getSession();
    const totpSecret = await TotpMultiFactorGenerator.generateSecret(
      multiFactorSession
    );
    return totpSecret
  }

  mfaEnabled() {
    const enrolledFactors = multiFactor(this.payload).enrolledFactors;
    return enrolledFactors.length > 0;
  }

  getEmail() {
    return this.payload.email;
  }

  async finalizeEnrollment(totpSecret: TotpSecret, verificationCode: string): Promise<void> {
    const multiFactorAssertion = TotpMultiFactorGenerator.assertionForEnrollment(
      totpSecret,
      verificationCode
    );
    return multiFactor(this.payload).enroll(multiFactorAssertion, "TOTP");
  }

  async deleteEnrollment() {
    const client = multiFactor(this.payload);
    return client.unenroll(client.enrolledFactors[0]);
  }
}